<template>
    <app-layout>
        <base-header :shadow="false" border border-bg-from="from-yellow-500" border-bg-to="to-orange-500">
            <div class="w-full">
                <h4 class="text-xl font-medium">
                    {{ $t('general.budget-projections') }}
                </h4>
            </div>
        </base-header>

        <store-selector @click="$inertia.visit(route('stores.budget-projections.index', [$event]))"></store-selector>
    </app-layout>
</template>

<script>
import StoreSelector from '@/Pages/Stores/Components/StoreSelector';

export default {
    components: {StoreSelector},

    metaInfo() {
        return {
            title: this.$t('general.budget-projections'),
        };
    },
};
</script>
